import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { ButtonProps } from '@carto/meridian-ds/components'
import { createApiError } from 'features/common/api/apiError'
import { ApiError } from 'features/common/types'
export const name = 'notification'

export enum AlertSeverity {
  Success = 'success',
  Error = 'error',
  Info = 'info',
  Warning = 'warning',
  Neutral = 'neutral'
}

export interface NotificationActions {
  labelId: string
  link: string
  type?: 'button' | 'link'
  variant?: ButtonProps['variant']
}

export interface NotificationState {
  showNotification: boolean
  notificationType: AlertSeverity
  actions?: NotificationActions[]
  notificationMessage?: string
  detailsMsg?: string
  error?: ApiError
  notificationFormattedMessage?: boolean
  formatValues?: Record<string, unknown>
  timeout?: number
  closeable?: boolean
  autoWidth?: boolean
}

const initialState: NotificationState = {
  showNotification: false,
  notificationType: AlertSeverity.Success,
  notificationFormattedMessage: false
}

export interface Notification {
  type: AlertSeverity

  /// Message or message title, if explanation is used.
  msg: string
  /// More elaborate message displayed below `msg`
  detailsMsg?: string
  error?: unknown

  /** If true, `msg` and `explanation` are message id`s rendered using react-intl. */
  formatted?: boolean
  formatValues?: Record<string, unknown>
  actions?: NotificationActions[]
  timeout?: number
  closeable?: boolean
  autoWidth?: boolean
}

const reducers = {
  showNotification: (state: NotificationState, action: PayloadAction<Notification>) => {
    state.notificationMessage = action.payload.msg
    state.actions = action.payload.actions
    state.notificationType = action.payload.type || AlertSeverity.Success
    state.notificationFormattedMessage = action.payload.formatted || false
    state.formatValues = action.payload.formatValues
    state.showNotification = true
    state.error = action.payload.error ? createApiError(action.payload.error) : undefined
    state.timeout = action.payload.timeout
    state.detailsMsg = action.payload.detailsMsg
    state.closeable = action.payload.closeable
    state.autoWidth = action.payload.autoWidth
  },
  hideNotification: (state: NotificationState) => {
    state.showNotification = false
  }
}

export const notificationSlice = createSlice({
  name,
  initialState,
  reducers
})

export const { showNotification, hideNotification } = notificationSlice.actions

export default notificationSlice.reducer
